import React from "react";
import EmptyState from "../../UI/EmptyState";

const ResultadoEvaluacionRow = ({ resultado }) => {
  const getEstadoBadge = (estado) => {
    switch (estado) {
      case "completada":
        return {
          class: "bg-success-focus text-success-main",
          label: "Completada",
        };
      case "en_progreso":
        return {
          class: "bg-warning-focus text-warning-main",
          label: "En Progreso",
        };
      case "sin_sesion":
        return {
          class: "bg-neutral-100 text-neutral-600",
          label: "Sin Iniciar",
        };
      default:
        return {
          class: "bg-neutral-100 text-neutral-600",
          label: estado,
        };
    }
  };

  const estadoBadge = getEstadoBadge(resultado.estado);

  return (
    <tr>
      <td>
        <div>
          <span className="text-md mb-0 fw-normal text-secondary-light">
            {resultado.email}
          </span>
          {resultado.nombre_completo && (
            <div className="text-sm text-secondary-light">
              {resultado.nombre_completo}
            </div>
          )}
        </div>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {resultado.escuela || "-"}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {resultado.plantel || "-"}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${estadoBadge.class}`}
        >
          {estadoBadge.label}
        </span>
      </td>
      <td>
        {resultado.porcentaje_completado ? (
          <div className="d-flex align-items-center gap-2">
            <div
              className="w-100 progress-bar-wrapper"
              style={{ maxWidth: "120px" }}
            >
              <div className="progress" style={{ height: "6px" }}>
                <div
                  className="progress-bar bg-primary-600"
                  role="progressbar"
                  style={{
                    width: `${parseFloat(resultado.porcentaje_completado)}%`,
                  }}
                  aria-valuenow={parseFloat(resultado.porcentaje_completado)}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
            </div>
            <span className="text-sm text-secondary-light">
              {(parseFloat(resultado.porcentaje_completado) ).toFixed(0)}%
            </span>
          </div>
        ) : (
          <span className="text-sm text-secondary-light">0%</span>
        )}
      </td>
      <td>
        <span className="text-sm text-secondary-light">
          {resultado.fecha_completado
            ? new Date(resultado.fecha_completado).toLocaleDateString("es-MX", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            : "-"}
        </span>
      </td>
    </tr>
  );
};

const TablaResultadosEvaluacion = ({ resultados, loading }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <span className="text-secondary-light">Cargando resultados...</span>
      </div>
    );
  }

  if (!resultados || resultados.length === 0) {
    return (
      <EmptyState
        icon="mdi:clipboard-text-search-outline"
        title="No hay resultados de evaluación"
        description="No se encontraron evaluaciones con los filtros aplicados"
      />
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th scope="col">Usuario</th>
            <th scope="col">Escuela</th>
            <th scope="col">Plantel</th>
            <th scope="col">Estado</th>
            <th scope="col">Progreso</th>
            <th scope="col">Fecha Completado</th>
          </tr>
        </thead>
        <tbody>
          {resultados.map((resultado, index) => (
            <ResultadoEvaluacionRow
              key={`${resultado.usuario_id}-${index}`}
              resultado={resultado}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TablaResultadosEvaluacion;
